<!--TopBar-->

<div class="container-fluid backgroundColor nav-border-bottom shark base container-height position-relative">
  <div class="row d-flex align-content-start flex-wrap">
    <div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 col-xl-6 col-12 pos-center -mb-5">
      <a href="#" class="navbar-brand d-block mx-auto my-auto">
        <object data="" type="">
          <img src="../../assets/images/logo/relojoariaFaria.svg" class="img-fluid m-3 imgRes" alt="" srcset="">
        </object>
      </a>
    </div>
    <div class="col-md-6 col-xs-6 col-lg-6 col-xl-6 col-12 mx-auto pos-center no-padd">
      <a href="/login" class="m-3 pos-center font-decoration text-white" *ngIf="user == ''"><fa-icon class="mr-3" [icon]="faUser"></fa-icon>Login</a>
      <a (click)="logout()" class="pos-center font-decoration text-white pointer" *ngIf="user != ''">Log Out</a>
      <a href="/admin" class="m-3 pos-center font-decoration text-white" *ngIf="user != ''"><fa-icon class="mr-3 ml-2" [icon]="faUser"></fa-icon>{{user}}</a>
      <a href="#" class="m-1 font-decoration text-white">PT</a>
      <span class="textColor new-orleans darken-2">|</span>
      <a href="#" class="m-1 font-decoration text-white">EN</a>
    </div>
  </div>
</div>

<div class="container backgroundColor mine-shaft base nav-border d-flex no-flex align-items-center py-3 pb-4 position-relative top-6 z-index">
  <nav class="navbar navbar-expand-md navbar-dark text-shadow">
    <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse" (click)="expandNav()">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <div class="navbar-nav">
        <a href="#" class="nav-item nav-link btn-size text-center title textColor new-orleans base" id="homeLink">INÍCIO</a>
        <a href="/clock" class="nav-item nav-link btn-size text-center title textColor new-orleans base" id="prodLink">RELÓGIOS</a>
        <a href="/joia" class="nav-item nav-link btn-size text-center title textColor new-orleans base" id="somoLink">JOIAS</a>
        <a href="/acessories" class="nav-item nav-link btn-size text-center title textColor new-orleans base" id="somoLink">ACESSÓRIOS</a>
        <a href="/servicos" class="nav-item nav-link btn-size text-center title textColor new-orleans base" id="somoLink">SERVIÇOS</a>
        <a href="/somos" class="nav-item nav-link btn-size text-center title textColor new-orleans base" id="somoLink">QUEM SOMOS</a>
        <a href="/contactus" class="nav-item nav-link btn-size text-center title textColor new-orleans base" id="contLink">CONTACTOS</a>
        <div class="form-inline ml-5 -mr-9">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-12 col-md-6 col-lg-6 input-group mb-2">
              <input class="form-control mr-sm-2 rounded" type="search" placeholder="Pesquisar" aria-label="Search" [(ngModel)]="query" (keydown.enter)="search()">
              <button class="btn btn-outline-mine-shaft rounded" type="submit" (click)="search()"><fa-icon [icon]="faSearch"></fa-icon></button>
            </div>
            <div class="d-flex">
              <div class="mr-2">
                <label class="textColor white">Produto</label>
              </div>
              <div>
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitch1" [(ngModel)]="queryM">
                  <label class="custom-control-label textColor white" for="customSwitch1">Marca</label>
                </div>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>